/**
 * Role Definitions
 * 
 * Centralized definition of all roles in the system.
 * Roles represent user types and should be extensible.
 */

export enum Role {
  ADMIN = 'Admin',
  OWNER = 'Owner',
  USER = 'User',
  PARTNER = 'Partner',
  ANGADIYA = 'Angadiya',
  ANGADIYA_ADMIN = 'Angadiya Admin',
  ANGADIYA_USER = 'AngadiyaUser',
}

/**
 * Type-safe role string union
 */
export type RoleType = Role | string;

/**
 * Array of all available roles
 */
export const ALL_ROLES: Role[] = Object.values(Role) as Role[];

/**
 * Check if a string is a valid role
 */
export const isValidRole = (role: string): role is Role => {
  return ALL_ROLES.includes(role as Role);
};

// Ensure this file is treated as a module
export {};

